import request from '../http';

export const listUsers = (params) =>
  request({ url: '/system/users', method: 'get', params });

export const createUser = (data) =>
  request({ url: '/system/users', method: 'post', data });

export const updateUser = (id, data) =>
  request({ url: `/system/users/${id}`, method: 'put', data });

export const deleteUsers = (ids) => {
  const idList = Array.isArray(ids) ? ids : [ids];
  return request({ url: `/system/users/${idList.join(',')}`, method: 'delete' });
};

export const deleteUser = (id) =>
  deleteUsers([id]);

export const assignUserRoles = (id, roleIds) =>
  request({ url: `/system/users/${id}/roles`, method: 'post', data: { ids: roleIds } });

export const getUserRoleIds = (id, config) =>
  request({ url: `/system/users/${id}/roles`, method: 'get', ...config });

/** 获取当前用户可分配的角色列表 */
export const getAssignableRoles = (config) =>
  request({ url: '/system/users/assignable-roles', method: 'get', ...config });

/** 用户绑定的投放旧系统(A)用户 ID 列表 */
export const listAdsBinds = (userId) =>
  request({ url: `/system/users/${userId}/ads-binds`, method: 'get' });

/** 全量保存绑定（可多选） */
export const saveAdsBinds = (userId, adsUserIds) =>
  request({ url: `/system/users/${userId}/ads-binds`, method: 'put', data: { adsUserIds: adsUserIds || [] } });

/** 从 A 系统按已关联部门同步用户（默认密码 123456，已存在登录名跳过） */
export const syncFromAdsDept = (aiDeptId) =>
  request({ url: '/system/users/sync-from-ads-dept', method: 'post', params: { aiDeptId } });
